import { render, staticRenderFns } from "./PurchaseLow.vue?vue&type=template&id=6c84fcde&scoped=true&"
import script from "./PurchaseLow.vue?vue&type=script&lang=js&"
export * from "./PurchaseLow.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseLow.vue?vue&type=style&index=0&id=6c84fcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84fcde",
  null
  
)

export default component.exports